import $ from 'jquery';
import screenSize from '../services/screen_size';

class MobileBottomSocialBar {
    constructor() {
        this.$window = $(window);
        this.scopedResizeListener = this.resizeListener.bind(this);
        this.scopedMobileScroll = this.mobileScroll.bind(this);
        this.lastY = window.scrollY;
        this.activeClass = 'active';
    }

    mobileScroll() {
        if (
            this.topOffset < this.$window.scrollTop() &&
            this.bottomOffset > this.$window.scrollTop() &&
            this.getDirection()
        ) {
            this.$nav.addClass(this.activeClass);
            this.$mobileSocialBar.addClass(this.activeClass);
        } else {
            this.$nav.removeClass(this.activeClass);
            this.$mobileSocialBar.removeClass(this.activeClass);
        }
        return this;
    }

    getDirection() {
        var currentY = window.scrollY;

        if (currentY > this.lastY) {
            this.lastY = currentY;
            return true;
        } else if (currentY < this.lastY) {
            this.lastY = currentY;
            return false;
        }
    }

    scrollListener() {
        if (screenSize.getSize() === 'small') {
            this.$window.on('scroll', this.scopedMobileScroll);
            return this;
        }
        this.off();
        return this;
    }

    resizeListener() {
        return this
            .off()
            .on();
    }

    on() {
        this.$nav = $('.navbar-brands-container');
        this.$shareButtons = $('.post-share-buttons');
        this.$mobileSocialBar = $('.mobile-bottom-social-bar');

        if (this.$shareButtons && this.$shareButtons.first() && this.$shareButtons.first().offset()) {
            this.topOffset = this.$shareButtons.first().offset().top;
            this.bottomOffset = this.$shareButtons.last().offset().top - this.$window.height();
            this.$window.on('resize', this.scopedResizeListener);
            return this.scrollListener();
        }
    }

    off() {
        this.$window.off('scroll', this.scopedMobileScroll);
        this.$window.off('resize', this.scopedResizeListener);
        return this;
    }
}

export default new MobileBottomSocialBar();

